import axiosInstance from '../axiosInterceptor/axiosInstance'

const reorderStages = async ({ orgId, seasonId, orderedIds }) => {
  const url = `v1/orgs/${orgId}/stages/reorder?seasonId=${seasonId}`
  const response = await axiosInstance.patch(url, JSON.stringify({ orderedIds }))
  return response?.data
}

export default reorderStages
